import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OpeningClosingHoursRequest, OpeningClosingHoursRequestUpdate } from '../../../models/api-store/opening-closing-hours/opening-closing-hours.request.model';
import { FALSE } from '../../../utils/config/const';
import { ConfigIntervalNameUpper, intervalsUpper } from '../../../utils/config/hours.config';
import { HoursService } from '../../../services/hours/hours.service';



@Component({
  selector: 'app-openingclosinghours-table',
  templateUrl: './openingclosinghours-table.component.html',
  styleUrls: ['./openingclosinghours-table.component.scss']
})
export class OpeningclosinghoursTableComponent implements OnInit, OnChanges {

  @Input() inputOpeningclosinghoursTable: OpeningClosingHoursRequest;
  @Input() hasOriginalOpeningclosinghours: boolean = false;
  @Input() isOnlyView: boolean;
  @Output() outputOpeningclosinghoursTable = new EventEmitter<any>();
  formBuilder: FormGroup;

  openingclosinghoursTable: OpeningClosingHoursRequest;
  giorniSettimana = ["Lunedi", "Martedi", "Mercoledi", "Giovedi", "Venerdi", "Sabato", "Domenica"]
  giorniSettimanaEng = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  orariMattina: string[];
  orariPomeriggio: string[];
  OpeningclosinghoursView = {
    monEFrom: [],
    monETo: [],
    monMFrom: [],
    monMTo: [],
    tueEFrom: [],
    tueETo: [],
    tueMFrom: [],
    tueMTo: [],
    wedEFrom: [],
    wedETo: [],
    wedMFrom: [],
    wedMTo: [],
    thuEFrom: [],
    thuETo: [],
    thuMFrom: [],
    thuMTo: [],
    friEFrom: [],
    friETo: [],
    friMFrom: [],
    friMTo: [],
    satEFrom: [],
    satETo: [],
    satMFrom: [],
    satMTo: [],
    sunEFrom: [],
    sunETo: [],
    sunMFrom: [],
    sunMTo: [],

    monApertura: true,
    tueApertura: true,
    wedApertura: true,
    thuApertura: true,
    friApertura: true,
    satApertura: true,
    sunApertura: true
  }

  isVisibleNote: boolean = true;

  constructor(
    private fb: FormBuilder,
    private hoursService: HoursService
  ) {
    if (this.isOnlyView == null || typeof this.isOnlyView == typeof undefined) {
      this.isOnlyView = false;
    }
    this.inputOpeningclosinghoursTable = new OpeningClosingHoursRequestUpdate();
    this.formBuilder = this.fb.group(this.inputOpeningclosinghoursTable, { updateOn: "change" });
    this.orariMattina = this.hoursService.generateTimeArray(7, 16, 5);
    this.orariPomeriggio = this.hoursService.generateTimeArray(12, 22, 5);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.inputOpeningclosinghoursTable != typeof undefined) {
      if (typeof changes.inputOpeningclosinghoursTable.currentValue != typeof undefined) {
        this.setValue();
        this.initOpeningclosinghoursView();
        this.setAllTableDsableRows();
        this.changeValue();
      }
    }
    if (typeof changes.isOnlyView != typeof undefined) {
      if (typeof changes.isOnlyView.currentValue != typeof undefined) {
        this.isOnlyView = changes.isOnlyView.currentValue;
      }
    }

  }

  ngOnInit(): void {
    if (this.isOnlyView == null || typeof this.isOnlyView == typeof undefined) {
      this.isOnlyView = false;
    }
    this.formBuilder = this.fb.group(new OpeningClosingHoursRequestUpdate(), { updateOn: "change" });
    this.setValue();
    this.initOpeningclosinghoursView();
    this.changeValue();
  }




  setAllTableDsableRows() {
    if (!this.isOnlyView) {
      for (let day of this.giorniSettimanaEng) {
        let valueMFrom = this.formBuilder.controls[day + ConfigIntervalNameUpper.MFrom].value;
        let valueMTo = this.formBuilder.controls[day + ConfigIntervalNameUpper.MTo].value;
        let valueEFrom = this.formBuilder.controls[day + ConfigIntervalNameUpper.EFrom].value;
        let valueETo = this.formBuilder.controls[day + ConfigIntervalNameUpper.ETo].value;
        let nameApertura = day + "Apertura";
        if (valueMFrom == "" && valueMTo == "" && valueEFrom == "" && valueETo == "") {
          this.OpeningclosinghoursView[nameApertura] = false;
        } else {
          this.OpeningclosinghoursView[nameApertura] = true;
        }
      }
    }
  }

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }

  /**
   * Setta i valori di input sul form
   */
  setValue() {
    if (typeof this.inputOpeningclosinghoursTable != typeof undefined) {
      this.formBuilder.controls["note"].setValue(this.inputOpeningclosinghoursTable["note"]);
      for (let day of this.giorniSettimanaEng) {
        this.setFormIntervalDay(day);

        if (!this.isOnlyView) {
          let valueMFrom = this.formBuilder.controls[day + ConfigIntervalNameUpper.MFrom].value;
          let valueMTo = this.formBuilder.controls[day + ConfigIntervalNameUpper.MTo].value;
          let valueEFrom = this.formBuilder.controls[day + ConfigIntervalNameUpper.EFrom].value;
          let valueETo = this.formBuilder.controls[day + ConfigIntervalNameUpper.ETo].value;
          if (valueMFrom == "" && valueMTo == "" && valueEFrom == "" && valueETo == "") {
            this.disableRow(day);
          } else {
            this.enableRow(day);
          }
        }
      }

      if (this.inputOpeningclosinghoursTable.type == 'STANDARD') {
        this.isVisibleNote = false;
      }
    }
  }

  setFormIntervalDay(day) {
    for (let obj of intervalsUpper) {
      if (typeof this.inputOpeningclosinghoursTable != typeof undefined) {
        if (this.inputOpeningclosinghoursTable[day + obj] == null) {
          this.inputOpeningclosinghoursTable[day + obj] = "";
        }
        if (typeof this.formBuilder != typeof undefined) {
          this.formBuilder.controls[day + obj].setValue(this.inputOpeningclosinghoursTable[day + obj]);
        }
      }
    }
  }

  /**
   * Setta i valori del form in output
   * @returns 
   */
  getValue() {
    let openingClosingHoursRequestUpdate = new OpeningClosingHoursRequestUpdate();
    for (let day of this.giorniSettimanaEng) {
      for (let obj of intervalsUpper) {
        let value = this.formBuilder.controls[day + obj].value;
        openingClosingHoursRequestUpdate[day + obj] = value;
      }
    }
    if (this.formBuilder.controls['note'] != undefined) {
      openingClosingHoursRequestUpdate.note = this.formBuilder.controls['note'].value;
    }
    return openingClosingHoursRequestUpdate;
  }

  /**
   * Aggiorna l'output
   */
  changeValue() {
    let output = this.getValue();
    this.outputOpeningclosinghoursTable.emit({
      output: output,
      status: this.formBuilder.status,
      touched: this.hasOriginalOpeningclosinghours || this.formBuilder.touched
    });
  }





  /* GESTIONE VIEW TABLE HOURS*/

  /**
   * Inizializza i range della view
   */
  initOpeningclosinghoursView() {
    for (let day of this.giorniSettimanaEng) {
      let valueMFrom = this.formBuilder.controls[day + ConfigIntervalNameUpper.MFrom].value;
      let valueMTo = this.formBuilder.controls[day + ConfigIntervalNameUpper.MTo].value;
      let valueEFrom = this.formBuilder.controls[day + ConfigIntervalNameUpper.EFrom].value;
      let valueETo = this.formBuilder.controls[day + ConfigIntervalNameUpper.ETo].value;
      let startValueMFrom = "0";
      let startValueMTo = "0";
      let startValueEFrom = "0";
      let startValueETo = "0";

      //Init start value MFrom

      //Init start value MTo
      if (valueMFrom != "") {
        startValueMTo = valueMFrom;
        startValueEFrom = valueMFrom;
        startValueETo = valueMFrom;
      }

      //Init start value EFrom
      if (valueMTo != "") {
        startValueEFrom = valueMTo;
        startValueETo = valueMTo;
      }

      //Init start value ETo
      if (valueEFrom != "") {
        startValueETo = valueEFrom;
      }

      //Init range MFrom
      this.OpeningclosinghoursView[day + ConfigIntervalNameUpper.MFrom] = this.getHoursByHour(startValueMFrom, 'M');

      //Init range MTo
      this.OpeningclosinghoursView[day + ConfigIntervalNameUpper.MTo] = this.getHoursByHour(startValueMTo, 'M');

      //Init range EFrom
      this.OpeningclosinghoursView[day + ConfigIntervalNameUpper.EFrom] = this.getHoursByHour(startValueEFrom, 'E');

      //Init range ETo
      this.OpeningclosinghoursView[day + ConfigIntervalNameUpper.ETo] = this.getHoursByHour(startValueETo, 'E');



      if (this.isOnlyView === FALSE) {
        let nameApertura = day + "Apertura";
        if (valueMFrom == "" && valueMTo == "" && valueEFrom == "" && valueETo == "") {
          this.OpeningclosinghoursView[nameApertura] = false;
        } else {
          this.OpeningclosinghoursView[nameApertura] = true;
        }
      }
    }

  }

  /**
   * Azione al click su Apertura di una riga
   * @param dayOfWeek 
   */
  toggleApertura(dayOfWeek) {
    let nameApertura = dayOfWeek + "Apertura";
    this.OpeningclosinghoursView[nameApertura] = !this.OpeningclosinghoursView[nameApertura];
    this.resetRow(dayOfWeek);
    if (this.OpeningclosinghoursView[nameApertura] === FALSE) {
      this.disableRow(dayOfWeek);
    } else {
      this.enableRow(dayOfWeek);
    }
  }

  /**
   * Abilita una riga
   * @param dayOfWeek 
   */
  enableRow(dayOfWeek) {
    if (dayOfWeek != "" && dayOfWeek != null && typeof dayOfWeek != typeof undefined) {
      for (let obj of intervalsUpper) {
        this.formBuilder.controls[dayOfWeek + obj].enable();
      }
    }
  }

  /**
   * Disabilita riga
   * @param dayOfWeek 
   */
  disableRow(dayOfWeek) {
    if (dayOfWeek != "" && dayOfWeek != null && typeof dayOfWeek != typeof undefined) {
      for (let obj of intervalsUpper) {
        this.formBuilder.controls[dayOfWeek + obj].disable();
      }
    }
  }

  /**
   * Reset valori di una riga
   * @param dayOfWeek 
   */
  resetValueRow(dayOfWeek) {
    if (dayOfWeek != "" && dayOfWeek != null && typeof dayOfWeek != typeof undefined) {
      for (let obj of intervalsUpper) {
        this.formBuilder.controls[dayOfWeek + obj].setValue('');
      }
      this.changeValue();
    }
  }

  /**
   * Reset range di una riga a partire dal valore del form
   * @param dayOfWeek 
   */
  resetRangeRow(dayOfWeek) {
    if (dayOfWeek != "" && dayOfWeek != null && typeof dayOfWeek != typeof undefined) {
      for (let obj of intervalsUpper) {
        let nameField = dayOfWeek + obj;
        if (obj.startsWith('M')) {
          this.OpeningclosinghoursView[nameField] = this.getHoursByHour('0', 'M');
        } else {
          this.OpeningclosinghoursView[nameField] = this.getHoursByHour('0', 'E');
        }
      }
    }
  }

  /**
   * Reset riga
   * @param dayOfWeek 
   */
  resetRow(dayOfWeek) {
    this.resetValueRow(dayOfWeek);
    this.resetRangeRow(dayOfWeek);
  }


  /**
   * Controlla se nella riga ci sono problemi ed in caso li segnala
   * @param dayOfWeek 
   */
  validateRow(dayOfWeek) {
    if (dayOfWeek != "" && dayOfWeek != null && typeof dayOfWeek != typeof undefined) {
      this.validateMFrom(dayOfWeek);
      this.validateMTo(dayOfWeek);
      this.validateEFrom(dayOfWeek);
      this.validateETo(dayOfWeek);
    }
  }


  /**
   * Controllo validità per il campo MFrom
   * @param dayOfWeek 
   * @returns 
   */
  validateMFrom(dayOfWeek) {
    let isValid = this.isValidateMFrom(dayOfWeek);
    if (isValid == FALSE) {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MFrom].setErrors([dayOfWeek + ConfigIntervalNameUpper.MFrom]);
    } else {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MFrom].setErrors(null);
    }
    return isValid;
  }

  isValidateMFrom(dayOfWeek) {
    let isValid = true;
    let valueNameFieldMFrom = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MFrom].value;
    let valueNameFieldMTo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MTo].value;
    let valueNameFieldEFrom = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.EFrom].value;
    let valueNameFieldETo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.ETo].value;
  
    // If MFrom is filled
    if (valueNameFieldMFrom !== "") {
      if (valueNameFieldMTo !== "" && this.hourToInt(valueNameFieldMFrom) >= this.hourToInt(valueNameFieldMTo)) {
        isValid = false;
      }
  
      if (valueNameFieldEFrom !== "" && this.hourToInt(valueNameFieldMFrom) >= this.hourToInt(valueNameFieldEFrom)) {
        isValid = false;
      }
  
      if (valueNameFieldETo !== "" && this.hourToInt(valueNameFieldMFrom) > this.hourToInt(valueNameFieldETo)) {
        isValid = false;
      }
    } else {
      if (valueNameFieldMTo !== "" || (valueNameFieldEFrom === "" && valueNameFieldETo !== "")) {
        isValid = false;
      }
    }
  
    return isValid;
  }


  /**
   * Controllo validità per MTo
   * @param dayOfWeek 
   * @returns 
   */
  validateMTo(dayOfWeek) {
    let isValid = this.isValidateMTo(dayOfWeek);
    if (isValid == FALSE) {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MTo].setErrors([dayOfWeek + ConfigIntervalNameUpper.MTo]);
    } else {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MTo].setErrors(null);
    }
    return isValid;
  }

  isValidateMTo(dayOfWeek) {
    let isValid = true;
    let valueNameFieldMFrom = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MFrom].value;
    let valueNameFieldMTo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MTo].value;
    let valueNameFieldEFrom = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.EFrom].value;
    let valueNameFieldETo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.ETo].value;
  
    // If MTo is filled
    if (valueNameFieldMTo !== "") {
      if (valueNameFieldMFrom !== "" && this.hourToInt(valueNameFieldMTo) <= this.hourToInt(valueNameFieldMFrom)) {
        isValid = false;
      }
  
      if (valueNameFieldEFrom !== "" && this.hourToInt(valueNameFieldMTo) >= this.hourToInt(valueNameFieldEFrom)) {
        isValid = false;
      }
  
      if (valueNameFieldETo !== "" && this.hourToInt(valueNameFieldMTo) > this.hourToInt(valueNameFieldETo)) {
        isValid = false;
      }
    } else {
      if ((valueNameFieldETo === "" && (valueNameFieldMFrom === "" || valueNameFieldEFrom === "")) || (valueNameFieldMFrom !== "" && valueNameFieldEFrom !== "" && valueNameFieldETo !== "")) {
        isValid = false;
      }
    }
  
    return isValid;
  }




  /**
   * Controllo validità per EFrom
   * @param dayOfWeek 
   */
  validateEFrom(dayOfWeek) {
    let isValid = this.isValidateEFrom(dayOfWeek);
    if (isValid == FALSE) {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.EFrom].setErrors([dayOfWeek + ConfigIntervalNameUpper.EFrom]);
    } else {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.EFrom].setErrors(null);
    }
    return isValid;
  }

  isValidateEFrom(dayOfWeek) {
    let isValid = true;
    let valueNameFieldMFrom = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MFrom].value;
    let valueNameFieldMTo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MTo].value;
    let valueNameFieldEFrom = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.EFrom].value;
    let valueNameFieldETo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.ETo].value;
  
    // If EFrom is filled
    if (valueNameFieldEFrom !== "") {
      if (valueNameFieldMFrom !== "" && this.hourToInt(valueNameFieldEFrom) <= this.hourToInt(valueNameFieldMFrom)) {
        isValid = false;
      }
  
      if (valueNameFieldMTo !== "" && this.hourToInt(valueNameFieldEFrom) <= this.hourToInt(valueNameFieldMTo)) {
        isValid = false;
      }
  
      if (valueNameFieldETo !== "" && this.hourToInt(valueNameFieldEFrom) >= this.hourToInt(valueNameFieldETo)) {
        isValid = false;
      }
    } else {
      if ((valueNameFieldETo === "" && (valueNameFieldMFrom === "" || valueNameFieldMTo === "")) || (valueNameFieldMFrom !== "" && valueNameFieldMTo !== "" && valueNameFieldETo !== "")) {
        isValid = false;
      }
    }
  
    return isValid;
  }




  /**
   * Controllo validità per ETo
   * @param dayOfWeek 
   */
  validateETo(dayOfWeek) {
    let isValid = this.isValidateETo(dayOfWeek);
    if (isValid == FALSE) {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.ETo].setErrors([dayOfWeek + ConfigIntervalNameUpper.ETo]);
    } else {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.ETo].setErrors(null);
    }
    return isValid;
  }


  isValidateETo(dayOfWeek) {
    let isValid = true;
    let valueNameFieldMFrom = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MFrom].value;
    let valueNameFieldMTo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MTo].value;
    let valueNameFieldEFrom = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.EFrom].value;
    let valueNameFieldETo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.ETo].value;
  
    // If ETo is filled
    if (valueNameFieldETo !== "") {
      if (valueNameFieldMFrom !== "" && this.hourToInt(valueNameFieldETo) <= this.hourToInt(valueNameFieldMFrom)) {
        isValid = false;
      }
  
      if (valueNameFieldMTo !== "" && this.hourToInt(valueNameFieldETo) <= this.hourToInt(valueNameFieldMTo)) {
        isValid = false;
      }
  
      if (valueNameFieldEFrom !== "" && this.hourToInt(valueNameFieldETo) <= this.hourToInt(valueNameFieldEFrom)) {
        isValid = false;
      }
    } else {
      if (valueNameFieldEFrom !== "" || valueNameFieldMFrom === "") {
        isValid = false;
      }
    }
  
    return isValid;
  }



  /**
   * Azione - quando cambia MFrom controllo e sistemo gli altri campi
   * @param dayOfWeek 
   */
  changeMFrom(dayOfWeek) {
    let valueNameFieldMFrom = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MFrom].value;
    let valueNameFieldMTo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MTo].value;
    let valueNameFieldEFrom = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.EFrom].value;
    let valueNameFieldETo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.ETo].value;

    //Aggiorno MTo
    if (valueNameFieldMTo != "" && this.hourToInt(valueNameFieldMTo) <= this.hourToInt(valueNameFieldMFrom)) {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MTo].setValue('');
    }
    this.OpeningclosinghoursView[dayOfWeek + ConfigIntervalNameUpper.MTo] = this.getHoursByHour(valueNameFieldMFrom, 'M');

    //Aggiorno EFrom
    if (valueNameFieldEFrom != "" && this.hourToInt(valueNameFieldEFrom) <= this.hourToInt(valueNameFieldMFrom)) {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.EFrom].setValue('');
    }
    this.OpeningclosinghoursView[dayOfWeek + ConfigIntervalNameUpper.EFrom] = this.getHoursByHour(valueNameFieldMFrom, 'E');

    //Aggiorno ETo
    if (valueNameFieldETo != "" && this.hourToInt(valueNameFieldETo) <= this.hourToInt(valueNameFieldMFrom)) {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.ETo].setValue('');
    }
    this.OpeningclosinghoursView[dayOfWeek + ConfigIntervalNameUpper.ETo] = this.getHoursByHour(valueNameFieldMFrom, 'E');

    //Valido riga
    this.validateRow(dayOfWeek);
    this.changeValue();
  }

  /**
   * Azione - quando cambia MTocontrollo e sistemo gli altri campi
   * @param dayOfWeek 
   */
  changeMTo(dayOfWeek) {
    let valueNameFieldMTo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.MTo].value;
    let valueNameFieldEFrom = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.EFrom].value;
    let valueNameFieldETo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.ETo].value;

    //Aggiorno EFrom
    if (valueNameFieldEFrom != "" && parseInt(valueNameFieldEFrom.split(':').join('')) < parseInt(valueNameFieldMTo.split(':').join(''))) {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.EFrom].setValue('');
    }
    this.OpeningclosinghoursView[dayOfWeek + ConfigIntervalNameUpper.EFrom] = this.getHoursByHour(valueNameFieldMTo, 'E');

    //Aggiorno ETo
    if (valueNameFieldETo != "" && parseInt(valueNameFieldETo.split(':').join('')) < parseInt(valueNameFieldMTo.split(':').join(''))) {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.ETo].setValue('');
    }
    this.OpeningclosinghoursView[dayOfWeek + ConfigIntervalNameUpper.ETo] = this.getHoursByHour(valueNameFieldMTo, 'E');

    //Valido riga
    this.validateRow(dayOfWeek);
    this.changeValue();
  }

  /**
   * Azione - quando cambia EFrom controllo e sistemo gli altri campi
   * @param dayOfWeek 
   */
  changeEFrom(dayOfWeek) {
    let valueNameFieldEFrom = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.EFrom].value;
    let valueNameFieldETo = this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.ETo].value;
    //Aggiorno ETo
    if (valueNameFieldETo != "" && parseInt(this.hourToInt(valueNameFieldETo)) < parseInt(this.hourToInt(valueNameFieldEFrom))) {
      this.formBuilder.controls[dayOfWeek + ConfigIntervalNameUpper.ETo].setValue('');
    }
    this.OpeningclosinghoursView[dayOfWeek + ConfigIntervalNameUpper.ETo] = this.getHoursByHour(valueNameFieldEFrom, 'E');
    //Valido riga
    this.validateRow(dayOfWeek);
    this.changeValue();
  }


  /**
   * Azione - quando cambia ETo controllo gli altri campi
   * @param dayOfWeek 
   */
  changeETo(dayOfWeek) {
    //Valido riga
    this.validateRow(dayOfWeek);
    this.changeValue();
  }







  /**
   * Aggiorna il range di orari da mostrare
   */
  getHoursByHour(startTime, interval) {
    let res = [];
    let orari = [];

    if (startTime != "") {
      startTime = parseInt(this.hourToInt(startTime));
    } else {
      startTime = 0;
    }
    if (interval == "M") {
      orari = this.orariMattina;
    } else {
      orari = this.orariPomeriggio;
    }
    for (let ora of orari) {
      if (startTime < parseInt(this.hourToInt(ora))) {
        res.push(ora);
      }
    }
    return res;
  }

  /**
   * Converte una string hour in int
   * @param val 
   * @returns 
   */
  hourToInt(val) {
    return val.split(':').join('');
  }





}
